import { render, staticRenderFns } from "./bookRecommend.vue?vue&type=template&id=658f7d5c&scoped=true&"
import script from "./bookRecommend.vue?vue&type=script&lang=js&"
export * from "./bookRecommend.vue?vue&type=script&lang=js&"
import style0 from "./bookRecommend.vue?vue&type=style&index=0&id=658f7d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f7d5c",
  null
  
)

export default component.exports